import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './eventDeskTabLayout.scss';
import Img from '../../../components/Img';
import { isTennisSportTypeEvent } from '../../../utils/events';

const EventDeskTabLayout = (props) => {
    const {
        showHeader,
        noPadding,
        fitScreen,
        children,
        className,
    } = props;

    const history = useHistory();
    const { event } = useSelector(({ drawEdit }) => {
        const { event } = drawEdit;
        return {
            event,
        };
    });

    const sportTypeId = event.data?.sportTypeId;

    const stylesForChildren = [
        styles.tabContent,
        noPadding ? styles.noPadding : '',
        !showHeader ? styles.noHeader : '',
        fitScreen ? styles.fitScreen : '',
    ].join(' ');

    const closeClickHandler = () => {
        history.push(`/events/${event.data.id}`);
    };

    return (
        <div className={`${styles.layout} ${className || ''}`}>
            {showHeader && (
                <div className={styles.header} data-testid="draw-edit.event-desk-layout.header">
                    Event desk: UTR Sports {isTennisSportTypeEvent(sportTypeId) ? 'Tennis' : 'Pickleball'} Event
                    <div className="mr8" onClick={closeClickHandler} data-testid="draw-edit.event-desk-layout.close-btn">
                        <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                    </div>
                </div>
            )}
            <div className={stylesForChildren}>
                {children}
            </div>
        </div>
    );
};

EventDeskTabLayout.propTypes = {
    showHeader: PropTypes.bool,
    noPadding: PropTypes.bool,
    fitScreen: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

EventDeskTabLayout.defaultProps = {
    showHeader: true,
    noPadding: false,
    fitScreen: false,
    className: null,
};

export default EventDeskTabLayout;
